module.exports = __webpack_public_path__ + "img/atl-spread.f9f6d435.jpg";